export function clearSessionStorage(): void {
  localStorage.clear();
}

export function getPathToRedirectLogin(): string {
  if ((window as any)._env_.REACT_APP_SSO_LOGIN_PROVIDER === 'primary') {
    return `${(window as any)._env_.REACT_APP_SSO}/sso?client_id=${(window as any)._env_.REACT_APP_CLIENT_ID}`;
  }

  return `${(window as any)._env_.REACT_APP_SSO_SECUNDARY}/auth?client_id=${(window as any)._env_.REACT_APP_CLIENT_ID}&response_type=${(window as any)._env_.REACT_APP_RESPONSE_TYPE}&redirect_uri=${(window as any)._env_.REACT_APP_REDIRECT_URI}`;
}

export function redirectToLogin(pathname: string): void {
  clearSessionStorage();
  localStorage.setItem('pathname_redirect_gov', pathname);
  window.open(getPathToRedirectLogin(), '_self');
}
